var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout layout--cart",attrs:{"id":"app"}},[_c('div',{staticClass:"cart__wrapper"},[_c('div',{staticClass:"cart__header"},[_c('announcements-bar'),_c('header-bar')],1),_c('div',{staticClass:"cart__content"},[_c('nuxt'),_c('footer-bar')],1)]),_c('div',{attrs:{"id":"footer"}}),_c('cookie-consent-alert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }